import { createIcon } from '../utils';

export const CircleViewIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.2002 0.699219C9.18511 0.699219 10.1604 0.893212 11.0703 1.27012C11.9803 1.64703 12.8071 2.19948 13.5035 2.89592C14.1999 3.59236 14.7524 4.41915 15.1293 5.3291C15.5062 6.23904 15.7002 7.21431 15.7002 8.19922M8.2002 0.699219V8.19922M8.2002 0.699219C4.05806 0.699219 0.700195 4.05708 0.700195 8.19922C0.700195 12.3414 4.05806 15.6992 8.2002 15.6992C12.3423 15.6992 15.7002 12.3414 15.7002 8.19922M8.2002 0.699219C12.3423 0.699219 15.7002 4.05709 15.7002 8.19922M15.7002 8.19922L8.2002 8.19922M15.7002 8.19922C15.7002 9.3828 15.4201 10.5496 14.8827 11.6041C14.3454 12.6587 13.5661 13.5712 12.6086 14.2668L8.2002 8.19922"
        stroke="currentColor"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'CircleViewIcon',
  },
);
